import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/** The selected Matchium mark, optimized from the approved brand artwork. */
export function BrandMark({ className = "w-9 h-9" }) {
  return (
    <div
      className={`${className} brand-mark relative shrink-0`}
    >
      <span
        className="brand-mark-primary absolute inset-0"
        style={{
          WebkitMask: "url(/matchium-logo-primary-mask.png) center / contain no-repeat",
          mask: "url(/matchium-logo-primary-mask.png) center / contain no-repeat",
        }}
        aria-hidden="true"
      />
      <img src="/matchium-logo-accent.png" alt="" className="absolute inset-0 w-full h-full object-contain" aria-hidden="true" />
    </div>
  );
}

/** Wordmark + mark. `to` makes it a link; `withTagline` adds the small subtitle. */
export default function BrandLogo({ to = "/", withTagline = false, markClass = "w-9 h-9", textClass = "text-lg", light = false, testId = "brand-logo" }) {
  const { t } = useTranslation();
  const inner = (
    <>
      <BrandMark className={markClass} />
      <div className="min-w-0">
        <div className={`font-display font-bold tracking-[-0.04em] leading-tight ${textClass} ${light ? "text-white" : ""}`}>
          {t("common.appName")}<span className="text-brand-lime">.</span>
        </div>
        {withTagline && (
          <div className={`text-xs ${light ? "text-white/70" : "text-muted-foreground"}`}>{t("common.tagline")}</div>
        )}
      </div>
    </>
  );
  if (!to) return <div className="flex items-center gap-2.5" data-testid={testId}>{inner}</div>;
  return <Link to={to} className="flex items-center gap-2.5" data-testid={testId}>{inner}</Link>;
}
